'use client';

import React from 'react';

import { Box, Container } from '@/components';

const WrapperBlog: React.FC<
  React.PropsWithChildren & {
    banner: React.ReactElement;
    readMoreBlogs: React.ReactElement;
  }
> = ({ children, banner, readMoreBlogs }) => {
  return (
    <>
      <Container>
        {banner}
        <Box
          display="flex"
          alignItems="flex-start"
          flexDirection={{ base: 'column', md: 'row-reverse' }}
          gap={7}
          marginTop={{ base: '52px', md: '41px' }}
          marginBottom={{ base: '60px', md: '47px' }}
        >
          <Box
            borderRadius="md"
            width={{ base: '100%', md: '55%', lg: '70%' }}
            paddingInline={{ base: '17px', md: '27px' }}
            paddingTop="17px"
            paddingBottom={{ base: '38px', md: '45px' }}
            backgroundColor="white"
            border="1px solid"
            borderColor="primary.50"
          >
            {children}
          </Box>
          {readMoreBlogs}
        </Box>
      </Container>
    </>
  );
};
export default WrapperBlog;
